import styled from 'styled-components';

const SvgText = styled.text`
  font-size: 13px;
`;

const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid ${({theme}) => theme.lightGray};
  background-color: ${({theme}) => theme.white};
  padding: ${({theme}) => theme.spacingHorizontal()} ${({theme}) => theme.spacingVertical()};
`;

const TooltipItem = styled.div`
  color: ${({color}) => color};
  display: inline-block;
  font-weight: ${({bold}) => (bold ? 'bold' : null)};
  padding: 0 ${({theme}) => theme.spacingVertical()};
  font-size: 13px;
`;

const LabelUl = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const LabelLi = styled.li`
  color: ${({color}) => color};
  display: inline-block;
  padding: 0 ${({theme}) => theme.spacingVertical()};
  font-size: 13px;
`;

export {SvgText, TooltipWrapper, TooltipItem, LabelUl, LabelLi};
